import { render, staticRenderFns } from "./Luggage.vue?vue&type=template&id=31f09b5c&scoped=true&"
import script from "./Luggage.vue?vue&type=script&lang=js&"
export * from "./Luggage.vue?vue&type=script&lang=js&"
import style0 from "./Luggage.vue?vue&type=style&index=0&id=31f09b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f09b5c",
  null
  
)

export default component.exports